import { TooltipModule } from 'ng2-tooltip-directive';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { AnalyticsCoreModule } from '../analytics-core/analytics-core.module';
import { BreadcrumbModule } from '../dashboard/breadcrumb/breadcrumb.module';
import { ContentModule } from '../dashboard/content/content.module';
import { DashboardModule } from '../dashboard/dashboard.module';
import { LayoutModule } from '../dashboard/layout/layout.module';
import { NavigationModule } from '../dashboard/navigation/navigation.module';
import { ResetPasswordComponent } from '../reset-password/reset-password.component';
import { WidgetLibraryModule } from '../widget-library/widget-library.module';
import { AuthRoutesModule } from './analytics.routing';
import { AnalyticsContentComponent } from './components/analytics-content.component';
import { AnalyticsComponent } from './components/analytics.component';
import { CanActivateAnalyticsGuard } from './guards/canactivate-analytics.guard';
import { AnalyticsDataModel } from './models/analytics.datamodel';
import { AnalyticsMapperService } from './services/analytics.mapper.service';
import { AnalyticsService } from './services/analytics.service';
import { AnalyticsDataChachingService } from './services/analytics.datacaching.service';
import { AnalyticsMixpanelService } from './services/analytics.mixpanel.service';

@NgModule({
	bootstrap: [AnalyticsComponent],
	declarations: [AnalyticsComponent, ResetPasswordComponent, AnalyticsContentComponent],
	exports: [AnalyticsComponent, AnalyticsContentComponent],
	imports: [
		AnalyticsCoreModule,
		WidgetLibraryModule,
		NavigationModule,
		BreadcrumbModule,
		LayoutModule,
		ContentModule,
		BrowserModule,
		DashboardModule,
		RouterModule,
		AuthRoutesModule,
		CommonModule,
		FormsModule,
		TooltipModule
	],
	providers: [
		CanActivateAnalyticsGuard,
		AnalyticsDataModel,
		AnalyticsMapperService,
		AnalyticsService,
		AnalyticsDataChachingService
	, AnalyticsMixpanelService]
})
export class AnalyticsModule {}
